import React from 'react';
import AccessControl from './AccessControl';

/**
 * ProtectedRoute Component
 * 
 * Wraps the Conectados game routes and requires access code validation
 * before allowing users to access the game content.
 */
function ProtectedRoute({ children }) {
  return (
    <AccessControl>
      {children}
    </AccessControl>
  );
}

export default ProtectedRoute;

